<template>
  <div :class="isPC ? 'invite-next':'invite-next-mobile' " id='invite-next'>
    <Icon v-if="isPC"></Icon>
    <Top v-if="!isPC"></Top>
    <Titles></Titles>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Inputs :type="'password'" v-on:inputText="getPassword" v-on:enterInput="enterInput"></Inputs>
    <Buttons ref=btn :type="'Accept'" :data="{type: type, password: password, account: account}" v-on:openErrorTip="openErrorTip"></Buttons>
    <div class="foot">
      <span>{{footText}}</span>
      <a @click="switchClick">{{footRouter}}</a>
    </div>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Top from '../components/Top'
  import Titles from '../components/Title'
  import Error from '../components/Error'
  import Account from '../components/Account'
  import Inputs from '../components/Inputs'
  import GetCode from '../components/GetCode'
  import Buttons from '../components/Buttons'
  import { checkDevice, checkEmail, checkPhone, checkUsername } from '../common/Common.js'
  import { getCountryCode } from '../common/CountryCode.js'
  import { errorFn } from '../common/ErrorMsg.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import translate from '../common/Translate.js'
  export default {
    data () {
      return {
        isPC: checkDevice(),
        errorShow: false,
        errorMsg: '',
        type: 0,
        account: this.$route.query.account,
        password: '',
        isEmail: checkEmail(this.$route.query.account),
        isPhone: checkPhone(this.$route.query.account),
        isAccount: checkUsername(this.$route.query.account),
        footText: translate('Not your account? '),
        footRouter: translate('Switch')
      }
    },
    components: {
      IconSwitch, Icon, Top, Titles, Error, Account, Inputs, GetCode, Buttons
    },
    mounted () {
      if (this.isEmail) {
      } else if (this.isPhone) {
        this.type = 1
        getCountryCode()
      } else if (this.isAccount) {
        this.type = 2
      }
      if (!this.isPC) {
        let inviteNext = document.getElementById('invite-next')
        inviteNext.className = 'invite-next-mobile'
        // title margin top 80 need to calc
        let topHeight = (window.screen.height - inviteNext.offsetHeight - 50 + 80) / 3
        inviteNext.style.top = topHeight + 50 - 80 + 'px'
      }
    },
    methods: {
      getName (data) {
        this.name = data
      },
      getPassword (data) {
        this.password = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      },
      switchClick () {
        // 埋点统计：老用户点击切换账号
        uploadWebEvent('SWITCH')
        let route = {
          path: '/',
          query: {
            token: this.$route.query['token'],
            type: this.$route.query['type']
          }
        }
        this.$router.push(route)
        // 埋点统计：邀请注册页点击查看用户协议
        // uploadWebEvent('INVITENEXT_AGGREMENT', {
        //   type: this.type
        // })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixin.scss';
  .invite-next {
    @include white-bg;
    min-height: 450px;
    margin-top: -225px;
    .button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 40px;
      .back {
        
      }
    }
    .foot {
      width: 100%;
      height: 14px;
      margin-top: 30px;
      margin-bottom: 60px;
      text-align: center;
      span {
        color: #939699;
      }
      a {
        color: #3f86de;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .invite-next-mobile {
    @include white-mobile-bg;
    min-height: 350px;
    .button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 40px;
      .back {
        
      }
    }
    .foot {
      width: 100%;
      height: 14px;
      margin-top: 30px;
      text-align: center;
      span {
        color: #939699;
      }
      a {
        color: #3f86de;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Invitenext.vue?03cb87c8